import Item from './model';

const reviver = ([key, val]) => {
  switch (key) {
    case 'questionNo':
      return [key, `${val}`];
    default:
      return [key, val];
  }
};

const create = (data) => new Item(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/WritingAssignment/ShortAnswer/model/Item/create.js